// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__vPyPG","total":"Cart_total__XMrQj","actions":"Cart_actions__rCvmT","button--alt":"Cart_button--alt__cqJFf","button":"Cart_button__cwGOg"};